export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/snapchat.fe01fd2.svg";